import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/helsingborg")(
  heritageCityRoute({
    citySlug: "helsingborg",
    angle:
      "I Helsingborg och nordvästra Skåne finns handels- och logistikföretag med lång historia, och många familjer med berättelser som sträcker sig över Öresund.",
    localUseCases: [
      "Livsberättelse med förälder i Helsingborg med omnejd",
      "Kunskapsarv i handels- och logistikbolag",
      "Företagshistoria med rötter i hamnstaden",
      "Släkthistoria över Öresund och Danmark",
      "Kunskapsöverföring inför pension",
      "Minnesfilm till jubileum eller minnesstund"
    ],
  }),
);
